<template>
  <div class="mobile-layout main_section">
    <HeaderMobileComponent :showHeader="true" />
    <div class="mobile-layout__content">
      <slot />
    </div>
    <FooterMobileComponent />
  </div>
</template>

<script>
import HeaderMobileComponent from '@/components/HeaderMobileComponent.vue';
import FooterMobileComponent from '@/components/FooterMobileComponent.vue';

export default {
  name: 'MobileLayout',
  components: {
    HeaderMobileComponent,
    FooterMobileComponent,
  },
};
</script>

<style scoped>
.mobile-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.mobile-layout__content {
  flex: 1;
}
</style>

